import { z } from 'zod/v4';
import { ACCESSIBLE_IMAGE_SCHEMA, IAccessibleImage } from './image.interfaces';
import { INormalText, NORMAL_TEXT_SCHEMA } from './text/text.interfaces';
import { Brand } from '../branded-types';
import { EFooterBlockType } from './footer-block-type.enums';
import { ILink, LINK_SCHEMA } from './link.interfaces';

export type LogoAreaId = Brand<string, 'logoAreaId'>;

export const LOGO_AREA_SCHEMA: z.ZodType<ILogoArea> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as LogoAreaId)
    .optional(),
  isActive: z.boolean(),
  headlines: z.array(NORMAL_TEXT_SCHEMA),
  texts: z.array(NORMAL_TEXT_SCHEMA).optional(),
  accessibleImages: z.array(ACCESSIBLE_IMAGE_SCHEMA),
  links: z.array(LINK_SCHEMA).optional(),
  type: z.enum(EFooterBlockType).optional(),
  orientation: z.enum(['vertical', 'horizontal']).optional(),
});

export interface ILogoArea {
  id?: LogoAreaId;
  isActive: boolean;
  headlines: INormalText[];
  texts?: INormalText[];
  accessibleImages: IAccessibleImage[];
  links?: ILink[];
  type?: EFooterBlockType | string;
  orientation?: 'vertical' | 'horizontal';
}
